<template>
    <b-col :cols="cols" class="without-padding-left">
        <span v-if="count === null">
            <i class="fas fa-spinner fa-pulse donors-count"></i>
        </span>
        <span class="donors-count">{{count}}</span> <br>{{label}}
    </b-col>
</template>

<script>
export default {
  props: {
    count: null,
    label: '',
    cols: null
  }
};
</script>

<style scoped>
.without-padding-left {
  padding-left: 0px !important;
}

.donors-count {
    font-size: large;
    color: red;
}
</style>
